import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-7" }
const _hoisted_2 = { class: "col-span-6" }
const _hoisted_3 = { class: "col-span-6" }
const _hoisted_4 = { class: "col-span-6" }
const _hoisted_5 = { class: "col-span-6" }
const _hoisted_6 = { class: "col-span-6" }
const _hoisted_7 = { class: "col-span-6" }
const _hoisted_8 = { class: "col-span-6" }
const _hoisted_9 = { class: "col-span-6" }
const _hoisted_10 = { class: "col-span-6" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import PatientLayout from './components/PatientLayout.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';

import FormSection from '@/components/FormSection.vue';
import TextInput from '@/components/inputs/TextInput.vue';
// import MobileNumber from '@/components/inputs/MobileNumber.vue';
import PageLoader from '@/components/PageLoader.vue';
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import Patient from '@/classes/Patient';
import { useRoute } from 'vue-router';
import { ref, onMounted, computed } from 'vue';
import { useNetworkStore } from '@/store/network';
import { onIonViewWillEnter } from '@ionic/vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ShowPage',
  setup(__props) {

const route       = useRoute();
const loader      = ref(true)
const errors      = ref([]);
const showError   = ref(false);
const errorMsg    = ref(false);
const form        = ref({})
const showSuccess = ref(false);

const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);

const patientId = ref(route.params.id);

const submit = () => {
    loader.value      = true;

    Patient.updatePatient(form.value)
    .then(() => {
        loader.value      = false;
        showSuccess.value = true
    })
    .catch((err) => {
        loader.value    = false;
        showError.value = true;
        errorMsg.value  = err.response.data.message;

        if(err.response.status == 422) {
            errors.value = err.response.data.errors;
        }
    })
}

const showPatient = () => {
    Patient.showPatient(patientId.value).then((response) => {
        loader.value = false;
        Object.assign(form.value, response.data)
    })
    .catch((err) => {
        loader.value    = false;
        showError.value = true;
        errorMsg.value  = err.response.data.message;
    })
}

onMounted(() => {
    loader.value = true;
    setTimeout(() => {
        console.log('Mounted Hook - Network: ' + isNetworkAvailable.value);
        showPatient();
    }, 1000);
})

onIonViewWillEnter(() => {
    loader.value = true;
    setTimeout(() => {
        console.log('Mounted Hook - Network: ' + isNetworkAvailable.value);
        showPatient();
    }, 1000);
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "View Patient",
    "show-back": "",
    backUrl: "/accounts/patients"
  }, {
    default: _withCtx(() => [
      _createVNode(PatientLayout, { patientId: patientId.value }, {
        contents: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(FormSection, null, _createSlots({
              title: _withCtx(() => [
                _cache[13] || (_cache[13] = _createTextVNode(" Patient Information ", -1))
              ]),
              description: _withCtx(() => [
                _cache[14] || (_cache[14] = _createTextVNode(" Relevant data and other details ", -1))
              ]),
              form: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(TextInput, {
                    modelValue: form.value.first_name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.first_name) = $event)),
                    id: "first_name",
                    name: "first_name",
                    disabled: "",
                    label: "First Name",
                    placeholder: "First Name"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(TextInput, {
                    modelValue: form.value.middle_name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.middle_name) = $event)),
                    id: "middle_name",
                    name: "middle_name",
                    disabled: "",
                    label: "Middle Name",
                    placeholder: "Middle Name"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(TextInput, {
                    modelValue: form.value.last_name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.last_name) = $event)),
                    id: "last_name",
                    name: "last_name",
                    disabled: "",
                    label: "Last Name",
                    placeholder: "Last Name"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(TextInput, {
                    modelValue: form.value.email_address,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.email_address) = $event)),
                    id: "email_address",
                    name: "email_address",
                    label: "Email Address",
                    placeholder: "Email Address",
                    disabled: !isNetworkAvailable.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(TextInput, {
                    modelValue: form.value.sex,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.sex) = $event)),
                    id: "sex",
                    name: "sex",
                    disabled: "",
                    label: "Gender",
                    placeholder: "Gender"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(TextInput, {
                    modelValue: form.value.birthdate,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.birthdate) = $event)),
                    id: "birthdate",
                    name: "birthdate",
                    disabled: "",
                    label: "Birthday",
                    placeholder: "Birthday"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(TextInput, {
                    modelValue: form.value.cellphone_number,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.cellphone_number) = $event)),
                    id: "cellphone_number",
                    name: "cellphone_number",
                    disabled: "",
                    label: "Mobile Number",
                    placeholder: "Mobile Number"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(TextInput, {
                    modelValue: form.value.patient_id,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.patient_id) = $event)),
                    id: "patient_id",
                    name: "patient_id",
                    disabled: "",
                    label: "Patient ID",
                    placeholder: "Patient ID"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(TextInput, {
                    modelValue: form.value.hospital_no,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.hospital_no) = $event)),
                    id: "hospital_no",
                    name: "hospital_no",
                    disabled: "",
                    label: "Hospital ID",
                    placeholder: "Hospital ID"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 2
            }, [
              (isNetworkAvailable.value)
                ? {
                    name: "actions",
                    fn: _withCtx(() => [
                      _createVNode(ButtonComponent, { onClick: submit }, {
                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                          _createTextVNode(" Save Changes ", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1024)
          ])
        ]),
        _: 1
      }, 8, ["patientId"]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[9] || (_cache[9] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[10] || (_cache[10] = ($event: any) => (showSuccess.value = false)),
        "action-text": "Close",
        title: "Patient",
        content: "Patient Email updated Successfully!"
      }, null, 8, ["show"]),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Warning",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[11] || (_cache[11] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[12] || (_cache[12] = ($event: any) => (showError.value = false)),
        errors: errors.value
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show", "errors"]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})